module.exports = __webpack_public_path__ + "img/T5-D-xh_15.018a719b.png";